import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { Stripe } from "@stripe/stripe-js";
import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";

export const StripeEmbeddedCheckoutModal = ({
  open,
  handleClose,
  stripe,
  clientSecret,
}: ModalCompProps & {
  stripe: Promise<Stripe | null> | null;
  clientSecret?: string;
}) => {
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      title="Secure Checkout"
      subtitle="Complete your payment without leaving Tikket."
      showBackIcon={false}
      showCloseIcon
      closeOnOverlayClick={false}
      fullScreen
      className="!h-[100dvh] !max-h-[100dvh] !rounded-none !p-4 md:!h-fit md:!max-h-[90dvh] md:!max-w-[840px] md:!rounded-2xl md:!p-6"
      dialogClassName="!my-4 !overflow-y-auto"
      containerClassName="!items-stretch !p-0 md:!items-center md:!px-[20px] md:!py-[20px]"
    >
      <div
        className="min-h-[640px] w-full"
        aria-label="Stripe embedded checkout"
      >
        {stripe && clientSecret ? (
          <EmbeddedCheckoutProvider
            stripe={stripe}
            options={{ clientSecret }}
          >
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        ) : undefined}
      </div>
    </ModalComponent>
  );
};
